import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
// import { ToastService } from 'src/app/services/toast.service';
import { ToastService } from '../../../services/toast.service';


@Component({
  selector: 'app-property-detail',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule],
  templateUrl: './property-detail.component.html',
  styleUrl: './property-detail.component.scss'
})
export class PropertyDetailComponent {
  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<PropertyDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }
}
